import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizeService } from '@g99-product-web-ui/shared-service';
import { orangeExclamationWarningIcon } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'lib-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrl: './delete-confirmation-modal.component.scss',
  standalone: false,
})
export class DeleteConfirmationModalComponent implements OnInit, OnDestroy {
  @Input() public title = 'Discard Changes';
  @Input() public isVisible = false;
  @Input() public descriptionHtml =
    'Are you sure you want to proceed?<br />This action cannot be undone.';
  @Input() public description = ''; // fallback plain text
  @Input() public confirmButtonText = 'Continue';
  @Input() public cancelButtonText = 'Cancel';
  @Input() public iconHtml?: string; // Optional: override icon HTML
  @Output() public emitContinue = new EventEmitter<string>();
  @Output() public emitCloseModal = new EventEmitter<void>();

  protected warningIcon!: SafeHtml;

  constructor(
    protected readonly _sanitizer: SanitizeService,
    private _renderer: Renderer2,
    private _el: ElementRef,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this.warningIcon = this._sanitizer.sanitizeContent(
      orangeExclamationWarningIcon,
      true
    );
  }

  ngOnInit(): void {
    this._renderer.appendChild(this._document.body, this._el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this._el.nativeElement && this._el.nativeElement.parentNode) {
      this._renderer.removeChild(this._document.body, this._el.nativeElement);
    }
  }

  protected onSave() {
    this.emitContinue.emit('sdvsdfe');
    this.close();
  }

  // Method triggered on Discard button
  protected onDiscard() {
    this.close();
  }

  // Close modal method
  protected close() {
    this.emitCloseModal.emit();
  }

  protected renderIcon() {
    return this.iconHtml
      ? this._sanitizer.sanitizeContent(this.iconHtml, true)
      : this.warningIcon;
  }
}
